const getters = {
  groups: state => type => {
    return state[type].groups
  },
};

export default getters;
